export default {
  title: {
    id: 'seller_options_integrations_empty_state_subtitle',
    defaultMessage: 'You have not connected any integration yet. Start now!',
  },
  altText: {
    id: 'seller_options_integrations_empty_alt_text',
    defaultMessage: 'No result image',
  },
}
